import { Collapse } from "@material-ui/core"
import Add from '@material-ui/icons/Add'
import * as FileSaver from "file-saver"
import React from 'react'
import * as XLSX from "xlsx"
import Button from '../../components/UI/Button/Button'
import Modal from '../../components/UI/Modal/Modal'
import Search from '../../components/UI/Search/Search'
import SelectBox from "../../components/UI/Select/Select"
import Spinner from "../../components/UI/Spinner/Spinner"
import Table from "../../components/UI/Table/Table"
import UnitFranchiseKioskForm from "../../components/UnitFranchiseKioskForm/UnitFranchiseKioskForm"
import FetchData from '../../shared/fetchData'
import './UnitFranchiseKiosks.css'

const UnitFranchiseKiosks = (props) => {

    const [unitFranchiseKiosks, setUnitFranchiseKiosks] = React.useState([])
    const [unitFranchiseKiosk, setUnitFranchiseKiosk] = React.useState('')
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [loading, setLoading] = React.useState(false)
    const [autoPlay, setAutoPlay] = React.useState(false)
    const [tableData, setTableData] = React.useState([])
    const [units, setUnits] = React.useState();
    const [kiosks, setKiosks] = React.useState();
    const [modalContent, setModalContent] = React.useState('')
    const [kiosk, setKiosk] = React.useState('')
    const [unit, setUnit] = React.useState('')
    const childRef = React.useRef();
    const [edit, setEdit] = React.useState(false)
    const [showForm, setShowForm] = React.useState(false)
    const [permission] = React.useState(window.localStorage.getItem("permission"))

    React.useEffect(() => {
        var raw = JSON.stringify({
            "pl": "10000",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/units/getUnits'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setUnits(result.units);
            })
            .catch(error => setLoading(false))
        var url = 'management/api/v1/kiosks/getKiosks'
        FetchData(raw, url).then(response => response.json())
            .then(result1 => {
                setKiosks(result1.kiosks);
            })
            .catch(error => setLoading(false))
    }, [autoPlay]);
    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
    }, [])

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "unitFranchiseKiosk": {
                unitId: unit?.value,
                kioskId: kiosk?.value,
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/franchises/getUnitFranchiseKiosks'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.unitFranchiseKiosks)
                    pushData(newList)
                    setUnitFranchiseKiosks(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const UnitFranchiseKioskChangeStateSubmited = (id) => {
        var raw = JSON.stringify({
            "unitFranchiseKiosk": {
                "id": id
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/franchises/changeUnitFranchiseKioskState'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    childRef.current.closeModal();
                    getData({ pageIndex: pageIndex, pageSize: pageSize });
                }
            })
            .catch(error => console.log())
    }
    const unitFranchiseKioskChangeState = (id) => {
        setModalContent(<div>
            <div className="row justify-content-center">
                آيا از تغيير وضعيت مطمئن هستيد؟
            </div>
            <div className="row justify-content-center mt-5">
                <div className="col-6">
                    <Button btnType="Success" clicked={() => UnitFranchiseKioskChangeStateSubmited(id)} >بله</Button>
                </div>
                <div className="col-6">
                    <Button btnType="General" clicked={() => childRef.current.closeModal()} >خير</Button>
                </div>
            </div>
        </div>)
        childRef.current.openModal();
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'unitDescription',
                header: 'حساب',
                align: 'center',
            },
            {
                accessorKey: 'kioskDescription',
                header: 'لاکر',
                align: 'center',
            },
            {
                accessorKey: 'isActive',
                header: 'وضعیت',
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                unitDescription: d.unitDescription,
                kioskDescription: d.kioskDescription,
                isActive: d.isActive && d.isActive == '1' ? 'فعال است' : 'فعال نیست',
            });
        })
        buttons.push({ id: 1, text: 'تغییر وضعیت', clicked: unitFranchiseKioskChangeState });
        buttons.push({ id: 2, text: 'ویرایش', clicked: editNewUnitFranchiseKiosk });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }

    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const refresh = (event) => {
        setUnit('');
        setKiosk('');
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }
    const editNewUnitFranchiseKiosk = (id, data) => {
        const ksk = data.filter(k => k.id === id);
        if (!!ksk && ksk.length > 0) {
            setUnitFranchiseKiosk(ksk[0]);
            setEdit(true);
            setShowForm(true);
        }
    }

    const afterCloseModal = (event) => {
    }

    const exportToCSV = (event) => {
        var raw = JSON.stringify({
            "unitFranchiseKiosk": {
                unitId: unit?.value,
                kioskId: kiosk?.value,
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/franchises/getUnitFranchiseKiosks'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportUnitFranchiseKiosk = []
                    let count = 0
                    const unitFranchiseKiosk = result.unitFranchiseKiosks.map(o => {

                        count++
                        exportUnitFranchiseKiosk.push({
                            'ردیف': count,
                            'لاکر': o.kioskDescription,
                            'حساب': o.unitDescription,
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportUnitFranchiseKiosk);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'UnitFranchiseKiosks' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }
    const changeUnit = (selectedOption) => {
        setUnit(selectedOption);
    }

    const changeKiosk = (selectedOption) => {
        setKiosk(selectedOption);
    }
    const addNewUnitFranchiseKiosk = () => {
        setEdit(false);
        setShowForm(true);
    }
    let unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName
            })
        })
    }

    let kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        kiosks.map(z => {
            kioskList.push({
                value: z.id,
                label: z.description
            })
        })
    }
    let form = <div>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr">
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            <SelectBox
                name="form-field-name"
                value={unit}
                placeholder="حساب"
                options={unitList}
                onChange={changeUnit}
                col="4 mt-2"
            />
            <SelectBox
                name="form-field-name"
                value={kiosk}
                placeholder="لاکر"
                options={kioskList}
                onChange={changeKiosk}
                col="4 mt-2"
            />
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2 ord-small-btns">
                <Button btnType="search-btn" clicked={search}>
                    <span className="tab-color">
                        جستجو
                    </span>
                </Button>
            </div>
            <div className="col-2 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
        </div>
    </div>
    return (
        <>
            {loading ? <Spinner /> : ''}
            <Collapse in={!showForm}>
                <div className="third-orders">
                    <Search class="franchises-search" form={form} />
                    {permission != null && permission.includes('UNIT_WRITE') ?
                        <div className="row justify-content-center mt-3 ml-3">
                            <div className="unitFranchiseGeneralBtn">
                                <div onClick={(event) => addNewUnitFranchiseKiosk(event)} className="Add mb-2">
                                    <Add className="UserIcon" />
                                </div>
                            </div>
                        </div>
                        : ''
                    }
                    <div className="row justify-content-center w-100 ml-0 mr-0">
                        {rerender ?
                            // <Spinner />
                            <Table hasDetails={false} data={unitFranchiseKiosks} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                            :
                            <Table hasDetails={false} data={unitFranchiseKiosks} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                        }
                    </div>
                    <Modal
                        content={modalContent}
                        ref={childRef}
                        closePermission="true"
                        closeModal={(event) => afterCloseModal(event)}
                    />
                </div>
            </Collapse>
            <Collapse in={showForm}>
                <UnitFranchiseKioskForm unitFranchiseKiosk={unitFranchiseKiosk} edit={edit}
                    toggleNewUnitFranchiseKioskForm={(event, value) => { setShowForm(value) }}
                    toggleNewUnitFranchiseKioskFormAndReload={(event, value) => {
                        getData({ pageIndex: pageIndex, pageSize: pageSize });
                        setShowForm(value);
                    }}
                />
            </Collapse>
        </>
    )
}
export default UnitFranchiseKiosks